import { render, staticRenderFns } from "./giftdataProduct.vue?vue&type=template&id=a13e1fe6&scoped=true"
import script from "./giftdataProduct.vue?vue&type=script&lang=js"
export * from "./giftdataProduct.vue?vue&type=script&lang=js"
import style0 from "./giftdataProduct.vue?vue&type=style&index=0&id=a13e1fe6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13e1fe6",
  null
  
)

export default component.exports